/* 🤖 this file was generated by svg-to-ts */
export var spxIconChevronLeft = {
    name: 'chevron_left',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\"><path d=\"M10.5 13.5L6 9L10.5 4.5L11.55 5.55L8.1 9L11.55 12.45L10.5 13.5Z\" fill=\"currentColor\"/></svg>"
};
